<aside
  class="flex h-full flex-col border-r border-slate-200 bg-white py-6 transition-[width] duration-200 dark:border-slate-800 dark:bg-slate-900"
  [class.w-16]="isCollapsed"
  [class.w-64]="!isCollapsed"
>
  <div class="mb-6 flex items-center justify-between px-4">
    <span class="text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400" [class.hidden]="isCollapsed">
      {{ i18n.translate('sidebar.menu') }}
    </span>
    <button
      type="button"
      class="rounded border border-slate-300 px-2 py-1 text-xs text-slate-600 dark:border-slate-700 dark:text-slate-300"
      (click)="toggleCollapse()"
      [attr.aria-pressed]="isCollapsed"
      [attr.title]="isCollapsed ? i18n.translate('sidebar.expand') : i18n.translate('sidebar.collapse')"
    >
      {{ isCollapsed ? '›' : '‹' }}
    </button>
  </div>
  <nav class="flex-1 space-y-2 overflow-y-auto px-2 pb-4 text-sm">
    <a
      *ngFor="let item of items"
      class="flex items-center gap-2 rounded px-3 py-2 hover:bg-slate-100 dark:hover:bg-slate-800"
      [routerLink]="item.path"
      routerLinkActive="bg-slate-100 dark:bg-slate-800"
      [attr.title]="labelFor(item)"
    >
      <span
        class="flex h-8 w-8 items-center justify-center rounded bg-slate-100 text-xs font-semibold text-slate-600 dark:bg-slate-800 dark:text-slate-300"
      >
        {{ labelFor(item).charAt(0) }}
      </span>
      <span [class.hidden]="isCollapsed">{{ labelFor(item) }}</span>
    </a>
  </nav>
  <div class="mt-auto px-2 pt-4">
    <button
      type="button"
      class="flex w-full items-center gap-2 rounded px-3 py-2 text-left text-sm text-slate-700 hover:bg-slate-100 dark:text-slate-200 dark:hover:bg-slate-800"
      nz-popconfirm
      [nzPopconfirmTitle]="i18n.translate('sidebar.logoutConfirm')"
      (nzOnConfirm)="logout()"
      [attr.title]="i18n.translate('sidebar.logout')"
    >
      <span
        class="flex h-8 w-8 items-center justify-center rounded bg-rose-100 text-xs font-semibold text-rose-600 dark:bg-rose-950 dark:text-rose-300"
      >
        ⎋
      </span>
      <span [class.hidden]="isCollapsed">{{ i18n.translate('sidebar.logout') }}</span>
    </button>
  </div>
</aside>
